import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';
import { DimensionSlug, validDimensionSlug } from '@features/reports';
import { TextField, Typography } from '@mui/material';
import { Fragment } from 'react';
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import { TOP_BOTTOM_NAMES } from '../slides/overview-slide-interface';

export type DimensionFieldsProps<T extends FieldValues> = {
  control: Control<T>;
  selectedDimensions: {
    headerId: FieldPath<T>;
    dimensionName: DimensionSlug | (typeof TOP_BOTTOM_NAMES)[number];
  }[];
};

export const DimensionFields = <T extends FieldValues>(
  props: DimensionFieldsProps<T>
) => {
  const { selectedDimensions } = props;

  return (
    <>
      <Typography component="h6" variant="h6">
        Dimension Headers and Key Takeaways
      </Typography>
      Blank values will use the default.
      {selectedDimensions.map(({ headerId, dimensionName }) => {
        const dimensionLabel = validDimensionSlug(dimensionName)
          ? apiSlugToDimensionName[dimensionName]
          : dimensionName;

        return (
          <Fragment key={headerId}>
            <h6>{dimensionLabel}</h6>
            <Controller
              name={headerId}
              control={props.control}
              render={({ field }) => (
                <TextField
                  {...field}
                  id={headerId}
                  name={headerId}
                  sx={{ width: '48%' }}
                  label={`Dimension Page Header (${dimensionLabel})`}
                  inputProps={{ maxLength: 160 }}
                />
              )}
            />
          </Fragment>
        );
      })}
    </>
  );
};
